import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { PatentsListService, PatentsListServiceImpl } from './service/patents-list.service';

export const patentsListModule = (bind: interfaces.Bind) => {
    bind(PatentsListService).to(PatentsListServiceImpl);
};
